import { normalizeChars } from "~/utils/text";
import { removeNonNumericalCharacters } from "~/utils/phone";
import { RegionComponent } from "~/types/scheduling";

const cleanZipCode = (zipCode: string) => {
    if (!zipCode) {
        return -1;
    }

    let baseZipCode = removeNonNumericalCharacters(zipCode);
    if (baseZipCode.length < 8) {
        baseZipCode = baseZipCode.padEnd(8, "0");
    }

    return parseInt(baseZipCode);
};

export const findRegionsByLocation = (
    regionsList: RegionComponent[],
    uf: string,
    cityName: string,
    neighborhood: string,
    zipCode: string
) => {
    const modifiedCityName = normalizeChars(cityName);
    const modifiedNeighborhood = normalizeChars(neighborhood);
    const modifiedZipCode = cleanZipCode(zipCode);

    const records = regionsList.filter((item) => item.uf === uf && item.cityName === modifiedCityName);
    const record = records.find(item => {
        if (item.regionDetectionMode === "cep") {
            const found = item.postalCodeRange.find(currentRange => {
                const [startRange, endRange] = currentRange;

                if (startRange && endRange) {
                    const start = parseInt(startRange);
                    const end = parseInt(endRange);

                    return modifiedZipCode >= start && modifiedZipCode <= end;
                }

                return false;
            });

            if (!found) {
                return item.neighborhoods.includes(modifiedNeighborhood);
            }

            return found;
        } else if (item.regionDetectionMode === "bairro") {
            return item.neighborhoods.includes(modifiedNeighborhood);
        }

        return false;
    })

    if (!record) {
        return null;
    }

    return record.region;
};
